import request from '@/utils/request'
const url = '/notice';
export function fetchList(params) {
    return request({
        url: url + '/list',
        method: 'get',
        params: params
    })
}
export function getNotPlanRead(params) {
    return request({
        url: url + '/getNotPlanRead',
        method: 'get',
        params: params
    })
}
export function fetchNotRead(params) {
    return request({
        url: url + '/getNotRead',
        method: 'get',
        params: params
    })
}
export function getNotice(params) {
    return request({
        url: url + '/getNotice',
        method: 'get',
        params: params
    })
}
export function updateRead(id) {
    return request({
        url: url + '/updateRead/' + id,
        method: 'post',
    })
}


// WEBPACK FOOTER //
// ./src/api/notice.js